(function () {
  'use strict';

  var DEBUG = false;
  var EVENT_PREFIX = 'glamory:';
  var ALLOWED_LEAD_TYPES = [
    'business_sample',
    'mixed_trial_order',
    'oem_odm',
    'wholesale_application',
    'general_contact',
    'whatsapp',
    'alibaba',
    'wholesale',
  ];
  var ALLOWED_DESTINATION_TYPES = ['whatsapp', 'alibaba', 'internal', 'form'];
  var EVENT_ACTIONS = {
    'glamory:whatsapp_click': 'click',
    'glamory:sample_interest': 'click',
    'glamory:trial_order_interest': 'click',
    'glamory:oem_odm_interest': 'click',
    'glamory:alibaba_click': 'click',
    'glamory:wholesale_cta_click': 'click',
    'glamory:wholesale_application_started': 'start',
    'glamory:wholesale_application_submitted': 'submit_success',
    'glamory:contact_form_started': 'start',
    'glamory:contact_form_submitted': 'submit_success',
  };

  function createEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return [
      'glm',
      Date.now().toString(36),
      Math.random().toString(36).slice(2, 10),
    ].join('-');
  }

  function normalizeEventName(eventName) {
    if (!eventName) return '';
    return eventName.indexOf(EVENT_PREFIX) === 0 ? eventName : EVENT_PREFIX + eventName;
  }

  function allowedValue(value, allowedValues) {
    return allowedValues.indexOf(value) !== -1 ? value : '';
  }

  function getAttribution() {
    var query = new URLSearchParams(window.location.search);

    function storedValue(key) {
      try {
        return window.sessionStorage.getItem('glamory_' + key) || '';
      } catch (error) {
        return '';
      }
    }

    function rememberValue(key, value) {
      if (!value) return storedValue(key);
      try {
        window.sessionStorage.setItem('glamory_' + key, value);
      } catch (error) {
        return value;
      }
      return value;
    }

    return {
      utm_source: rememberValue('utm_source', query.get('utm_source') || ''),
      utm_medium: rememberValue('utm_medium', query.get('utm_medium') || ''),
      utm_campaign: rememberValue('utm_campaign', query.get('utm_campaign') || ''),
      utm_content: rememberValue('utm_content', query.get('utm_content') || ''),
      utm_term: rememberValue('utm_term', query.get('utm_term') || ''),
    };
  }

  function getLandingPage() {
    var landingPage = window.location.pathname + window.location.search;

    try {
      var storedLandingPage = window.sessionStorage.getItem('glamory_landing_page');
      if (storedLandingPage) return storedLandingPage;
      window.sessionStorage.setItem('glamory_landing_page', landingPage);
    } catch (error) {
      return landingPage;
    }

    return landingPage;
  }

  function getReferrerHost() {
    if (!document.referrer) return '';

    try {
      return new URL(document.referrer).hostname;
    } catch (error) {
      return '';
    }
  }

  function getCtaLabel(element) {
    if (!element) return '';

    return (element.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  function buildPayload(eventName, eventData) {
    var attribution = getAttribution();

    return {
      schema_version: '1.0',
      event_id: createEventId(),
      event_timestamp: new Date().toISOString(),
      page_path: window.location.pathname,
      page_title: document.title,
      section: eventData.section || '',
      action: EVENT_ACTIONS[eventName],
      lead_type: allowedValue(eventData.leadType || '', ALLOWED_LEAD_TYPES),
      cta_label: (eventData.ctaLabel || '').slice(0, 100),
      destination_type: allowedValue(eventData.destinationType || '', ALLOWED_DESTINATION_TYPES),
      utm_source: attribution.utm_source,
      utm_medium: attribution.utm_medium,
      utm_campaign: attribution.utm_campaign,
      utm_content: attribution.utm_content,
      utm_term: attribution.utm_term,
      referrer_host: getReferrerHost(),
    };
  }

  function reportDebugFailure() {
    if (DEBUG && window.console && typeof window.console.warn === 'function') {
      window.console.warn('GLAMORY analytics event could not be published.');
    }
  }

  function publishGlamoryEvent(rawEventName, eventData) {
    var eventName = normalizeEventName(rawEventName);

    if (!Object.prototype.hasOwnProperty.call(EVENT_ACTIONS, eventName)) return;
    if (
      !window.Shopify ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publish !== 'function'
    ) {
      return;
    }

    try {
      var publishResult = window.Shopify.analytics.publish(
        eventName,
        buildPayload(eventName, eventData),
      );

      if (publishResult && typeof publishResult.catch === 'function') {
        publishResult.catch(reportDebugFailure);
      }
    } catch (error) {
      reportDebugFailure();
    }
  }

  function bindCtaClicks() {
    document.addEventListener('click', function (clickEvent) {
      if (!clickEvent.target || typeof clickEvent.target.closest !== 'function') return;

      var trigger = clickEvent.target.closest('[data-glamory-event]');
      if (!trigger) return;

      publishGlamoryEvent(trigger.dataset.glamoryEvent, {
        section: trigger.dataset.glamorySection || '',
        leadType: trigger.dataset.glamoryLeadType || '',
        ctaLabel: getCtaLabel(trigger),
        destinationType: trigger.dataset.glamoryDestinationType || '',
      });
    });
  }

  function bindFormStarts() {
    var startedForms = new WeakSet();

    document.querySelectorAll('[data-glamory-start-event]').forEach(function (wrapper) {
      var form = wrapper.querySelector('form');
      if (!form) return;

      var publishStart = function (interactionEvent) {
        if (!interactionEvent.target || typeof interactionEvent.target.closest !== 'function') return;

        var control = interactionEvent.target.closest('input, select, textarea');
        if (!control || !form.contains(control) || startedForms.has(form)) return;

        startedForms.add(form);
        publishGlamoryEvent(wrapper.dataset.glamoryStartEvent, {
          section: wrapper.dataset.glamorySection || '',
          leadType: wrapper.dataset.glamoryLeadType || '',
          ctaLabel: '',
          destinationType: 'form',
        });
      };

      form.addEventListener('focusin', publishStart);
      form.addEventListener('change', publishStart);
    });
  }

  function publishSuccessfulForms() {
    document.querySelectorAll('[data-glamory-success-event]').forEach(function (marker) {
      publishGlamoryEvent(marker.dataset.glamorySuccessEvent, {
        section: marker.dataset.glamorySection || '',
        leadType: marker.dataset.glamoryLeadType || '',
        ctaLabel: '',
        destinationType: 'form',
      });
    });
  }

  function populateAttributionFields() {
    var query = new URLSearchParams(window.location.search);
    var attribution = getAttribution();
    var values = {
      utm_source: attribution.utm_source,
      utm_medium: attribution.utm_medium,
      utm_campaign: attribution.utm_campaign,
      utm_content: attribution.utm_content,
      utm_term: attribution.utm_term,
      landing_page: getLandingPage(),
      current_page: window.location.href,
      referrer: document.referrer || '',
      product_title: query.get('product_title') || '',
      product_sku: query.get('product_sku') || '',
      product_url: query.get('product_url') || '',
    };

    document.querySelectorAll('[data-glamory-attribution]').forEach(function (field) {
      var key = field.dataset.glamoryAttribution;
      if (Object.prototype.hasOwnProperty.call(values, key)) {
        field.value = String(values[key]).slice(0, 1000);
      }
    });

    var requestedSubject = query.get('subject');
    if (requestedSubject) {
      document.querySelectorAll('select[name="contact[Subject]"]').forEach(function (select) {
        var matchingOption = Array.prototype.some.call(select.options, function (option) {
          return option.value === requestedSubject;
        });
        if (matchingOption) select.value = requestedSubject;
      });
    }
  }

  function initialize() {
    populateAttributionFields();
    bindCtaClicks();
    bindFormStarts();
    publishSuccessfulForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
